window.stopBackgroundAudioRow = [];
window.listBackgroundAudioOptions = [];
window.loopAudio = false;
window.stopAudioOnNewTrial = true;
window.audioStopCountdown = -1;

function parseAudioColumn(value) {
    value = value.trim();
    /*
        Audio column could contain:
        Filename.mp3
        or
        Filename.mp3, start: START_CONDITION, until: END_CONDITION
        or
        stop

        where END_CONDITION can be:
            Nt (where N is the number of trials after which the audio is stopped t stands for trials )
            XmYs (X minutes and Y seconds after which audio is stopped)
            Number (trial row where audio is stopped)
            label
            loop
            end (until the end of the experiment or audio file)

        any of these can be stopped with typing just stop in the audio column

        where START_CONDITION can be:
            delay=Xms: Delays the audio playback by X milliseconds after the start condition. "delay=" can be omitted, the same for "ms": X is also valid. Time is measured from after the ITI.
    */
    if (value === "na") {
        return;
    }

    const valueSplit = value.split(',');
    const audioFile = valueSplit[0].trim();

    if (audioFile === 'stop') {
        const audioOptions = {
            filename: 'na',
            stop: true
        };
        return audioOptions;
    }

    const audioOptions = {
        filename: audioFile,
        loop: false,
        type: 'default'
    };
    if (window.inPreviewMode) {
        //skip parsing any options in preview mode
        return audioOptions;
    }

    for (let i = 1; i < valueSplit.length; i++) {
        console.log(valueSplit[i]);
        parseAudioUntil(valueSplit[i], audioOptions);
        parseAudioStart(valueSplit[i], audioOptions);
    }

    return audioOptions;
}

function parseAudioUntil(value, audioOptions) {
    const name = value.split(':')[0].trim();
    if (name !== 'until') {
        return;
    }

    const untilCondition = value.split(':')[1].replaceAll(/\s+/g, '');
    console.log('untilCondition', untilCondition);
    const untilRegex = /(?<trial_count>\d+t)|(?<time>(?:(\d+)m)?(\d+)s)|(?<trial_row>\d+)|(?<loop>loop)|(?<end>end)|(?<trial_label>\w+)/gm;
    const matches = untilRegex.exec(untilCondition)?.groups;

    if (!matches) {
        return;
    }

    let c = undefined;

    if (c = matches.trial_count) {
        //trial count stop
        audioOptions.loop = true;
        audioOptions.trials = parseInt(c, 10);
    } else if (c = matches.time) {
        //timer
        audioOptions.loop = true;
        audioOptions.time = window.parseTime(c);
    } else if (c = matches.trial_row) {
        //trial row stop
        audioOptions.loop = true;
        audioOptions.trialRow = parseInt(c, 10);
        stopBackgroundAudioRow[audioOptions.trialRow - 2] = 1;
    } else if (matches.loop) {
        //loop
        audioOptions.loop = true;
    } else if (matches.end) {
        //end
        audioOptions.end = true;
        audioOptions.loop = false;
    } else if (c = matches.trial_label) {
        //label
        audioOptions.loop = true;
        const labelRow = window.getTrialWithLabel(c.trim());
        if (labelRow !== -1) {
            stopBackgroundAudioRow[labelRow] = 1;
        }
    }
}

// where START_CONDITION can be:
// delay=Xms: Delays the audio playback by X milliseconds after the start condition. "delay=" can be omitted, the same for "ms": X is also valid.
function parseAudioStart(value, audioOptions) {
    const name = value.split(':')[0].trim();
    if (name !== 'start') {
        return;
    }

    const startCondition = value.split(':')[1].replaceAll(/\s+/g, '');
    const startRegex = /((delay\=)?(?<delay>\d+(ms)?))/gm;
    const matches = startRegex.exec(startCondition)?.groups;

    if (!matches) {
        return;
    }

    let c = undefined;

    if (c = matches.delay) {
        //delay
        audioOptions.delay = parseInt(c, 10);
    }
}

function stopBackgroundAudio() {
    if (!window.stopAudioOnNewTrial) {
        return;
    }

    audioElement = document.getElementById('audio1');
    // for auxiliary audio
    if (audioElement) {
        try {
            audioElement.pause()
            audioElement.removeEventListener('ended', endThis);
            audioElement.loop = false;
            audioElement = null;
        } catch (e) { }
    }
}